import { withDefaults } from '@warp-drive/legacy/model/migration-support';

const ReportsSchema = withDefaults({
  type: 'report',
  objectExtensions: ['report'],
  fields: [
    {
      kind: 'attribute',
      name: 'name',
    },
    {
      kind: 'attribute',
      name: 'description',
    },
    {
      kind: 'attribute',
      name: 'reportType',
    },
    {
      kind: 'attribute',
      name: 'searchConfig',
    },
    {
      kind: 'attribute',
      name: 'metadata',
    },
    {
      kind: 'attribute',
      name: 'partnerAccessConfig',
    },
    // Derived server-side from partnerAccessConfig, which is stored in two
    // shapes. Read these; never re-derive them from the raw column.
    {
      kind: 'attribute',
      name: 'visibleToAllPartners',
    },
    {
      kind: 'attribute',
      name: 'partnerIncludeList',
    },
    {
      kind: 'attribute',
      name: 'partnerExcludeList',
    },
    {
      kind: 'attribute',
      name: 'visibilityLevel',
    },
    {
      kind: 'attribute',
      name: 'createdBy',
    },
    {
      kind: 'attribute',
      name: 'createdAt',
    },
    {
      kind: 'attribute',
      name: 'updatedAt',
    },
    // The API omits both fields unless the viewer holds an internal builder role.
    {
      kind: 'attribute',
      name: 'internalPublishedAt',
    },
    {
      kind: 'attribute',
      name: 'sqlBacked',
    },
  ],
});

export default ReportsSchema;
